import { exists } from '@/helpers/utilities'; 
import { createFocusTrap } from 'focus-trap'; 

let SpeedBump = (({}) => { 
    class SpeedBump { 
        constructor(node, selector) { 
            this.node = node; 
            this.whitelist = cuModalConfig; 
            this.selector = selector; 
            this.linkSelector = `a[href]:not([href^="/"]):not([href^="#"]):not(.allow-external):not([href^="mailto:"]):not([href^="tel:"])`; 
            this.nodeExists = exists(this.node); 
            if (!this.nodeExists) return; 
            
            this.proceedLink = this.node.querySelector(`[data-js="proceed"]`); 
            this.closeBtns = this.node.querySelectorAll(`[data-action="close"]`); 
            this.overlay = this.node.querySelector('[data-js="overlay"]'); 
            
            this.onKeydownBound = this.onKeydown.bind(this); 
            this.onOverlayClickBound = this.onOverlayClick.bind(this); 
            
            this.focusTrap = createFocusTrap(selector, {}); 
            this.animationFrameId = null;
        } 

        isWhitelisted(link) { 
            if (!this.whitelist.length) return; 
            if (!this.isValidUrl(link)) return true; 
            let { hostname } = new URL(link); 
            let matches = this.whitelist.filter((site) => { 
                return hostname.indexOf(site) !== -1; 
            }); 
            return matches.length; 
        } 

        fadeIn(duration = 300) {
            cancelAnimationFrame(this.animationFrameId);
            
            this.node.style.opacity = 0;
            this.node.style.display = 'block';
            
            let startTime = performance.now();
            
            const animate = (currentTime) => {
                let elapsed = currentTime - startTime;
                let progress = Math.min(elapsed / duration, 1);
                
                this.node.style.opacity = progress;
                
                if (progress < 1) {
                    this.animationFrameId = requestAnimationFrame(animate);
                }
            };
            
            this.animationFrameId = requestAnimationFrame(animate);
        }

        fadeOut(duration = 300, callback) {
            cancelAnimationFrame(this.animationFrameId);
            
            let startOpacity = parseFloat(this.node.style.opacity) || 1;
            let startTime = performance.now();
            
            const animate = (currentTime) => {
                let elapsed = currentTime - startTime;
                let progress = Math.min(elapsed / duration, 1);
                
                this.node.style.opacity = startOpacity * (1 - progress);
                
                if (progress < 1) {
                    this.animationFrameId = requestAnimationFrame(animate);
                } else {
                    this.node.style.display = 'none';
                    if (typeof callback === 'function') callback();
                }
            };
            
            this.animationFrameId = requestAnimationFrame(animate);
        }

        showNode() { 
            this.fadeIn(300);
        } 

        hideNode(callback) { 
            this.fadeOut(300, callback); 
        } 

        setProceedLink(link) { 
            this.proceedLink.setAttribute('href', link); 
        } 

        closeModal() { 
            this.hideNode(() => {
                this.focusTrap.deactivate(); 
                this.node.setAttribute('aria-modal', false); 
                this.node.setAttribute('aria-hidden', true); 
            });

            window.removeEventListener('keydown', this.onKeydownBound, true); 
            if (this.overlay) { 
                this.overlay.removeEventListener('click', this.onOverlayClickBound); 
            } 
            document.body.classList.remove('modal-open');
        } 

        openModal() { 
            this.showNode(); 
            window.addEventListener('keydown', this.onKeydownBound, true); 
            if (this.overlay) { 
                this.overlay.addEventListener('click', this.onOverlayClickBound); 
            } 
            this.node.setAttribute('aria-modal', true); 
            this.node.setAttribute('aria-hidden', false); 
            this.focusTrap.activate(); 
            document.body.classList.add('modal-open');
        } 

        isValidUrl(_string) { 
            const matchpattern = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm; 
            return matchpattern.test(_string); 
        } 

        onLinkClick(e) { 
            let clickedLink = e.currentTarget.getAttribute('href'); 
            if (!clickedLink) return; 
            if (this.isWhitelisted(clickedLink)) return; 
            e.preventDefault(); 
            this.setProceedLink(clickedLink); 
            this.openModal(); 
        } 

        onOverlayClick(e) { 
            e.preventDefault(); 
            e.stopPropagation(); 
            this.closeModal(); 
        } 

        onKeydown(e) { 
            if (e.key === 'Escape' || e.key === 'Esc') { 
                e.preventDefault(); 
                e.stopPropagation(); 
                this.closeModal(); 
            } 
        } 

        setEventBindings() { 
            let allLinks = document.querySelectorAll(this.linkSelector); 
            if (!allLinks.length) return; 
            [...allLinks].map((link) => { 
                if (!exists(link)) return; 
                link.addEventListener('click', this.onLinkClick.bind(this)); 
            }); 
            if (!this.closeBtns.length) return; 
            [...this.closeBtns].map((btn) => { 
                btn.addEventListener('click', this.closeModal.bind(this)); 
            }); 
        } 

        init() { 
            this.setEventBindings(); 
        } 
    } 

    return { 
        init({ selector }) { 
            let nodeList = document.querySelectorAll(selector); 
            if (!nodeList.length) return; 
            return [...nodeList].map((node) => { 
                let module = new SpeedBump(node, selector); 
                module.init(); 
                return module; 
            }); 
        }, 
    }; 
})(window); 

export default Object.create(SpeedBump);